import { type } from "../types/index";
import VersionVehiculoService from "../services/versionVehiculo.service";
import { UpdateSecurityKey } from "../helpers/SecurityKey";

export const versionVehiculo = (user, id, modelo, idMarca, securityKey) => (dispatch) => {
    dispatch({type: type.clearMessage});
    dispatch({type: type.setLoading});
    dispatch({type: type.resetVersionVehiculo});
    return VersionVehiculoService.getVersionVehiculo( user, id, modelo, idMarca, securityKey ).then(
        (data) => {
            dispatch({type: type.setLoading});
            if(data.Codigo === 0) {
                const reformateo = data.Descripcion.map((item) => {
                    const container = {};
                    container["label"] = item.Descripcion;
                    container["value"] = item.IdDescripcion;
                    return container;
                });
                data.Descripcion = reformateo;
                dispatch({
                    type: type.getVersionVehiculo,
                    payload: data
                });
                UpdateSecurityKey(data.llaveSeguridad);
            } else {
                dispatch({
                    type: type.getVersionVehiculoFail
                });
                dispatch({
                    type: type.setError,
                    payload: {
                        tipoError: data.Codigo,
                        mensajeError: data.Mensaje
                    }
                });
            }
            
            dispatch({
                type: type.textMessage,
                payload: data,
            });
            return Promise.resolve(data);
        },
        (error) => {
            const message = (error.response && error.response.data && error.response.data.message) ||
            error.message || error.toString();
            dispatch({type: type.setLoading});
            dispatch({
                type: type.getVersionVehiculoFail
            });
            dispatch({
                type: type.textMessage,
                payload: message
            });
            dispatch({
                type: type.setError,
                payload: {
                    tipoError: 0,
                    mensajeError: message
                }
            });
            return Promise.reject(error);
        }
    )
}

export const versionVehiculoSeguro = (user, id, modelo, idMarca, securityKey) => (dispatch) => {
    dispatch({type: type.clearMessage});
    dispatch({type: type.setLoading});
    dispatch({type: type.resetVersionVehiculo});
    return VersionVehiculoService.getVersionVehiculoSeguros( user, id, modelo, idMarca, securityKey ).then(
        (data) => {
            dispatch({type: type.setLoading});
            if(data.Codigo === 0) {
                const reformateo = data.Descripcion.map((item) => {
                    const container = {};
                    container["label"] = item.Descripcion;
                    container["value"] = item.IdDescripcion;
                    return container;
                });
                data.Descripcion = reformateo;
                dispatch({
                    type: type.getVersionVehiculo,
                    payload: data
                });
                UpdateSecurityKey(data.llaveSeguridad);
            } else {
                dispatch({
                    type: type.getVersionVehiculoFail
                });
                dispatch({
                    type: type.setError,
                    payload: {
                        tipoError: data.Codigo,
                        mensajeError: data.Mensaje
                    }
                });
            }
            
            dispatch({
                type: type.textMessage,
                payload: data,
            });
            return Promise.resolve(data);
        },
        (error) => {
            const message = (error.response && error.response.data && error.response.data.message) ||
            error.message || error.toString();
            dispatch({type: type.setLoading});
            dispatch({
                type: type.getVersionVehiculoFail
            });
            dispatch({
                type: type.textMessage,
                payload: message
            });
            dispatch({
                type: type.setError,
                payload: {
                    tipoError: 0,
                    mensajeError: message
                }
            });
            return Promise.reject(error);
        }
    )
}
